import Head from 'next/head';
import React from 'react';
import FeatureBranch from '@/common/FeatureBranch';
import PageFooter from '@/common/PageFooter';
import PageHeader from '@/common/PageHeader';
import StructuredData from '@/vm/StructuredData';

export default function VmCommonContainer(props: React.PropsWithChildren<{}>) {
  return (
    <>
      <Head>
        <title>Carvana Vending Machines | Carvana</title>
        <meta
          key="description"
          name="description"
          content="Our snacks come in a variety of drivable flavors, come check out a Carvana Vending Machine in your neighborhood today."
        />
        <link
          key="canonical"
          rel="canonical"
          href="https://www.carvana.com/vending-machine"
        />
        <link
          rel="icon"
          type="image/x-icon"
          href={`${process.env.CVNA_APP_CDN_URL}/icons/favicon.ico`}
        />
      </Head>

      <StructuredData />

      <PageHeader />

      <FeatureBranch />

      <div className="mx-auto max-w-[1800px]">{props.children}</div>

      <PageFooter />
    </>
  );
}
